import { UserInviteAcceptedDtoModelType } from '../../../models';
import getAppRoot from '../../../utils/getAppRoot';

export default ({ store }: UserInviteAcceptedDtoModelType) => () => {
  const rootStore = getAppRoot(store);
  rootStore.team.fetchTeamMembers();
};
